import React from 'react';
import ME from '../../../assets/we.png';
import Background from '../../Basic/background/Background';
import CV from './CV';
import './header.css';
import HeaderSocial from './headerSocial';
const Header = () => {
  return (
    <header>
      <div className="container header-container">
        <div className="header-margin">
          <h5>Hello, I'm </h5>
          <h2>Aoumara Yacine</h2>
          <h5 className="text-light">Full-Stack</h5>
          <CV />
        </div>
        <HeaderSocial />
        <div className="me">
          <img src={ME} alt="my photo" className='myPhoto' />
        </div>
        <a href="#contact" className="scroll-down">
          Scroll Down
        </a>
        <Background />
      </div>
    </header>
  );
};

export default Header;
